import { providers } from '../../providers';
import { wavespeed } from '../wavespeed';
import type { VideoModelEntry } from '../types';

// 价格表: 美元/秒
const SORA2 = { '720p': 0.1};
const SORA2_PRO = { '720p': 0.3, '1k': 0.5, '1080p': 0.7 };
// 查找价格函数
const lookup = (table: Record<string, number>, quality?: string) =>
    table[quality?.toLowerCase() ?? ''] ?? Math.max(...Object.values(table));

const COST_FACTOR = 1.5;

export const openaiModels: VideoModelEntry[] = [
    {
        id: 'sora-2-official',
        chef: providers.openai,
        providers: [
            {
                ...providers.openai,
                model: wavespeed('sora-2-official'),
                getCost: ({ duration, quality }) => {
                    return duration * lookup(SORA2, quality) * COST_FACTOR;
                },
                getPassCount: ({ duration, quality }) => {
                    return duration * lookup(SORA2, quality) * COST_FACTOR * 100;
                },
            },
        ],
        configByMode: {
            none: {
                aspectRatios: ['16:9', '9:16'],
                durations: [4, 8, 12, 16, 20],
                qualities: ['720p'],
                inlineMedia: {
                    image: { allow: false },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
            first: {
                aspectRatios: [],
                durations: [4, 8, 12, 16, 20],
                qualities: ['720p'],
                inlineMedia: {
                    image: { allow: true, maxCount: 1, maxSize: '10MB', formats: ['image/png', 'image/jpeg'] },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
        },
        precheckByMode: {
            none: ['prompt'],
            first: ['prompt', 'image'],
        },
        supportsEdit: false,
        supportsInput: ['t2v', 'first'],
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    {
        id: 'sora-2-pro-official',
        chef: providers.openai,
        providers: [
            {
                ...providers.openai,
                model: wavespeed('sora-2-pro-official'),
                getCost: ({ duration, quality }) => {
                    return duration * lookup(SORA2_PRO, quality) * COST_FACTOR;
                },
                getPassCount: ({ duration, quality }) => {
                    return duration * lookup(SORA2_PRO, quality) * COST_FACTOR * 100;
                },
            },
        ],
        configByMode: {
            none: {
                aspectRatios: ['16:9', '9:16'],
                durations: [4, 8, 12, 16, 20],
                qualities: ['720p', '1k', '1080p'],
                inlineMedia: {
                    image: { allow: false },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
            first: {
                aspectRatios: [],
                durations: [4, 8, 12, 16, 20],
                qualities: ['720p', '1k', '1080p'],
                inlineMedia: {
                    image: { allow: true, maxCount: 1, maxSize: '10MB', formats: ['image/png', 'image/jpeg'] },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
        },
        precheckByMode: {
            none: ['prompt'],
            first: ['prompt', 'image'],
        },
        supportsEdit: false,
        supportsInput: ['t2v', 'first'],
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
];